<template>
    <v-container fluid >
        <v-layout row wrap>
            <v-flex xs12>
                    <v-stepper v-model="position" vertical :class="{'m': $vuetify.breakpoint.smAndDown,'M': $vuetify.breakpoint.mdAndUp}" style="border-radius: 5px; background: rgba(255,255,255,0.99)">
                        <v-card-title>
                            <div primary-title>
                                <h3 class="headline mb-0">{{title}}</h3>
                                <br>
                                <div v-html="description"></div>
                            </div>
                        </v-card-title>
                        <template v-for="(step, index) in steps.filter(function (el) {return !el.hidden})">
                            <v-stepper-step  :step="index+1" :complete="position > index" editable :key="step.id" :rules="stepRules(step, index, position)">
                               {{step.title}}
                               <step-header v-if="step.detail" :step="step"></step-header>
                            </v-stepper-step>
                            <v-stepper-content :step="index+1"  :key="`${step.id}-content`">
                                <step-content :step="step" @next="next"></step-content>
                            </v-stepper-content>
                        </template>
                        <v-stepper-step  :step="stepsFilter.length +1"  editable>Finalizar </v-stepper-step>
                        <v-stepper-content :step="stepsFilter.length+1">
                            <div v-if="!error">
                                <v-alert outline color="info" icon="info" :value="true">
                                    Comprueba que todos los datos son correctos antes de enviar
                                </v-alert>
                                <slot></slot>
                                <v-btn depressed color="primary" @click.native="generate">Enviar</v-btn>
                            </div>
                            <div v-else>
                                <v-alert outline color="error" icon="warning" :value="true">
                                    Hay datos incorrectos o incompletos. Por favor revise todos los campos
                                </v-alert>
                                <slot></slot>
                                <v-btn flat @click.native="() => position=1">Atrás</v-btn>
                            </div>
                        </v-stepper-content>
                    </v-stepper>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import SInput from "./Input";
    import StepContent from "./StepContent";
    import StepHeader from "./StepHeader";

    export default {
        components: {
            StepHeader,
            StepContent,
            SInput},
        name: "s-form",
        props: ['title', 'description', 'steps'],
        data () {
            return {
                position: 0,
            }
        },
        computed: {
            stepsFilter: function () {
               return this.steps.filter(function (el) {return !el.hidden})
            },
            error: function () {
                var aux = false
                var steps = this.steps.filter(function (el) {return !el.hidden})
                for(var i = 0; i < steps.length; i++){
                    if(!this.checkStepRules(steps[i])) aux = true
                }
                return aux
            }
        },
        methods : {
            checkStepRules: (step) => {
                var aux = true
                if (step.inputs) {
                    for (var i = 0; i < step.inputs.length; i++) {
                        var input = step.inputs[i]
                        if (input.rules && !input.hidden) {
                            for (var j = 0; j < input.rules.length; j++) {
                                var rule = input.rules[j]
                                var value = input.value
                                if (rule === 'required' && !value) aux = false
                                if (rule === 'required' && value && value.length === 0) aux = false
                                else if (rule === 'email' && !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) aux = false
                                //else if (rule === 'date') r.push((value) => /(\d{4})-(\d{2})-(\d{2})/.test(value))
                            }
                        }
                    }
                }
                return aux
            },
            stepRules  (step, index, position)  {
                var r = [];
                var self = this
                if (position > index +1) {
                    r.push(() => self.checkStepRules(step))
                }
                return r;

            },
            condition (step){
                this.$watch(
                    function () {
                        var id_step = step.condition.step;
                        var id_input = step.condition.input;
                        var s = this.steps.filter(function (el) {
                            return el.id === id_step
                        })[0];
                        if(s && s.inputs){
                            var input = s.inputs.filter(function (el) {
                                return el.id === id_input
                            })[0];
                            return input ? input.value : null;
                        }
                        else return null

                    },
                    function (value) {
                        for(var key in step.condition){
                            if (step.condition.hasOwnProperty(key) && key !== 'input' && key !== 'step' ) {
                                step.hidden = false;
                                if(typeof step.condition[key][value] !== 'undefined') step[key] = step.condition[key][value]
                                else if(typeof step.condition[key]['default'] !== 'undefined') step[key] = step.condition[key]['default']
                                else step.hidden = true;
                            }
                        }
                    }
                )
            },
            generate(){
                var form = {}
                form.date = new Date()
                var steps = this.steps.filter(function (el) {return !el.hidden})
                for(var i = 0; i < steps.length; i++){
                    var step = steps[i]
                    form[step.id] = {}
                    for(var j = 0; j < step.inputs.length; j++){
                        var input = step.inputs[j]
                        var value = input.value
                        if(step.id && input.id) {
                            if (step.id === 'basic' && value) form[input.id] = value
                            else if (value) form[step.id][input.id] = value
                        }
                    }
                }
                this.$emit('submit', form)
            },
            next() {  this.position++;  }
        },
        created () {
            for (var id in this.steps){
                if(this.steps[id].condition)  this.condition(this.steps[id])

            }
        }
    }
</script>

<style scoped>
 .m {
     padding: 4px;
 }
    .M {
        padding: 32px;
    }
</style>